var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"success-box"},[_c('b-img',{attrs:{"src":"/img/smile.png","center":true}}),_c('h4',{staticClass:"title"},[_c('strong',[_vm._v(_vm._s(_vm.$t("pages.completeRegistrationOk.ok")))])]),_c('p',{staticClass:"thanks"},[_vm._v(_vm._s(_vm.$t("pages.completeRegistrationOk.thanks")))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }